<template>
	<div>
		<a-spin :spinning="loading">
			<span @click="onShowModal">
				<slot>
					<a-button type="primary">选择影厅</a-button>
					<span> 已选{{targetKeys.length}}影厅</span>
				</slot>
			</span>
			<a-modal v-model:visible="visible" width="850px" title="影厅" @cancel="onCancel" @ok="onOk">
				<a-spin :spinning="loading">
					<div>
						<a-transfer v-model:targetKeys="targetKeys"
							v-model:selectedKeys="selectedRowKeys"
							:rowKey="record => { return record.id }"
							:data-source="dataList"
							:filter-option="(inputValue, item) => item.name.indexOf(inputValue) !== -1"
							:showSelectAll="false" 
							showSearch
						>
						<!-- @change="onChange" -->
							<template #children="{ 
									direction,
									disabled,
									filteredItems,
									selectedKeys,
									onItemSelect,
									onItemSelectAll
								}"
							>
								<div style="padding: 0 8px;">
									<a-table rowKey="id" :dataSource="filteredItems" :pagination="pagination"
										:columns="columns"
										:rowSelection="{
											type: type,
											selectedKeys: selectedKeys, 
											onSelect: (record, selected) => onSelectChange(record, selected, onItemSelect), 
											onSelectAll: (selected) => onSelectAll(selected, onItemSelectAll)
										}"
										size="small">
									</a-table>
								</div>
							</template>
						</a-transfer>
					</div>
				</a-spin>
			</a-modal>
		</a-spin>
	</div>
</template>

<script>
	import { getHallList } from '@/service/modules/cinema.js';
	export default {
		model: {
			prop: 'value'
		},
		props: {
			value: {
				type: Array,
				default: () => {
					return []
				}
			},
			type: { // checkbox or radio
				type: String,
				default: 'checkbox'
			},
			id: { // 影院ID
				type: null,
				default: undefined
			},
			disabled: {
				type: Boolean,
				default: false
			}
		},
		watch: {
			id(newVal) {
				this.pagination.current = 1;
				//this.pagination.pageSize = 10;
				this.getData();
			},
			value(newVal) {
				this.targetKeys = newVal;
			}
		},
		created() {
			this.targetKeys = this.value;
		},
		data() {
			return {
				targetKeys: [],
				loading: false,
				visible: false,
				selectedRowKeys: [], // 选择的id集合
				selectedListData: [], // 选择的数据集合
				selectedListIdDataMap: {}, // 每选中一项时的数据对比字典，防止分页后数据丢失
				classifyList: [],
				dataList: [],
				columns: [{
					title: '编码',
					dataIndex: 'code'
				}, {
					title: '名称',
					dataIndex: 'name'
				}],
				modelRef: {},
				searchData: {},
				pagination: {
					showSizeChanger: true,
					showQuickJumper: true,
					size: "middle",
					showTotal: (total) => {
						return "共 " + total + " 条";
					},
					total: 0,
					current: 1,
					pageSize: 10,
					onChange: (page) => {
						this.pagination.current = page;
						this.getData();
					},
					onShowSizeChange: (page, pageSize) => {
						this.pagination.current = 1;
						this.pagination.pageSize = pageSize;
						this.getData();
					}
				},
			}
		},
		methods: {
			onSearch() {
				this.pagination.current = 1;
				this.getData();
			},
			async getData() {
				this.loading = true;
				try {
					let ret = await getHallList({
						cinemaId: this.id
					})
					this.loading = false;
					if (ret.code === 200) {
						// this.pagination.total = ret.data.totalCount;
						ret.data.forEach(item => {
							item.id = item.id.toString();
						})
						this.dataList = ret.data;
					}
				} catch(e) {
					this.loading = false;
				}
			},
			onShowModal() {
				if (!this.id) {
					return this.$message.warn('请先选择所属影院');
				}
				if (this.disabled) return;
				this.getData();
				this.visible = true;
				this.selectedRowKeys = [];
				this.targetKeys = JSON.parse(JSON.stringify(this.value));
			},
			onSelectChange(record, selected, onItemSelect) {
				if (this.type === 'checkbox') {
					if (selected) {
						// this.selectedListData.push(JSON.parse(JSON.stringify(record)));
						this.selectedRowKeys.push(record.id);
					} else {
						this.selectedRowKeys.splice(this.selectedRowKeys.indexOf(record.id), 1);
						// this.selectedListData = this.selectedListData.filter(item => {
						// 	return item.id !== record.id;
						// });
					}
				} else {
					if (selected) {
						// this.selectedListData = [JSON.parse(JSON.stringify(record))];
						this.selectedRowKeys = [record.id];
					} else {
						this.selectedRowKeys = [];
					}
				}
				onItemSelect(record.id, selected);
			},
			onSelectAll(selected, onItemSelectAll) {
				if (selected) {
					this.dataList.forEach(item => {
						if (this.selectedRowKeys.indexOf(item.id) === -1) {
							// this.selectedListData.push(JSON.parse(JSON.stringify(item)));
							this.selectedRowKeys.push(item.id);
						}
					})
				} else {
					this.dataList.forEach(item => {
						if (this.selectedRowKeys.indexOf(item.id) !== -1) {
							// this.selectedListData.splice(this.selectedRowKeys.indexOf(item.id), 1);
							this.selectedRowKeys.splice(this.selectedRowKeys.indexOf(item.id), 1);
						}
					})
				}
				onItemSelectAll(this.selectedRowKeys, selected)
			},
			resetBtn() {
				this.$refs.formRef.resetFields();
				this.onSearch();
			},
			onCancel() {
				this.visible = false;
				this.targetKeys = JSON.parse(JSON.stringify(this.value));
			},
			onOk() {
				let selectedListData = [];
				this.dataList.forEach(item => {
					if (this.targetKeys.includes(item.id)) {
						selectedListData.push(item);
					}
				})
				this.$emit('update:value', JSON.parse(JSON.stringify(this.targetKeys)));
				this.$emit('change', JSON.parse(JSON.stringify(selectedListData)));
				this.visible = false;
			},
			onChange(e) {
				this.selectedRowKeys = [];
			}
		}
	}
</script>

<style scoped>
	.ui-form-item {
		margin-right: 20px;
	}
</style>
